<div class="card-header">
  <app-breadcrumb currentPage="rapportage bewerken"></app-breadcrumb>
</div>

<div class="card-body">
  <table class="table table-hover full-width">
    <thead>
    <th>rapport</th>
    <th colspan="4">status</th>
    </thead>
    <tr *ngFor="let report of reports">
      <td>{{ service.getReportName(report.code) }} {{ report?.year }}</td>
      <td>{{ report.state }}</td>
      <td>
        <button class="link"
                [disabled]="report.state != stateEnum.NotCreated"
                (click)="create(report)">aanmaken
        </button>
      </td>
      <td>
        <button class="link"
                [disabled]="report.state != stateEnum.Finished"
                (click)="undoFinished(report)">openzetten
        </button>
      </td>
      <td>
        <button class="link"
                [disabled]="report.state != stateEnum.Open"
                (click)="close(report)">sluiten
        </button>
      </td>
    </tr>
  </table>
  <div class="spacer"></div>
  <button class="btn arrow-left"
          routerLink="../">terug naar rapportage-overzicht
  </button>
</div>
